import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_right_middle} from '../../assets/arrow_right_middle.svg';

const ArrowRightMiddle: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} component={arrow_right_middle} viewBox='0 0 179 179' />
  );
};

export default ArrowRightMiddle;
